module.exports = __webpack_public_path__ + "img/categoryLoader.79298ab7.gif";